/**
 * Ro'yxat sahifa hajmi (2026-10-25, foydalanuvchi: "per page list ko'rinish tanlash ... har bir shunaqa list bo'lib ko'rinishi mumkin
 * bo'lgan joylarga"): 25 / 50 / 100 (backend max_page_size -- 100). Har ro'yxat uchun alohida, shu brauzerda eslab qolinadi.
 * URL'da `page_size` bo'lgan ro'yxatlarda (havola bilan ulashiladi) URL ustun, tanlov ikkalasiga ham yoziladi.
 */
import { useState } from "react";

export const PAGE_SIZES = [25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;

const storageKey = (list: string) => `page-size:${list}`;

export function validPageSize(value: unknown): number | null {
  const n = Number(value);
  return PAGE_SIZES.includes(n) ? n : null;
}

/** Eslab qolingan hajm; yo'q bo'lsa -- ro'yxatning o'z standarti (`fallback`) */
export function rememberedPageSize(list: string, fallback = DEFAULT_PAGE_SIZE): number {
  try {
    return validPageSize(localStorage.getItem(storageKey(list))) ?? fallback;
  } catch {
    return fallback;
  }
}

/** URL'dagi `page_size` (havola) ustun, bo'lmasa eslab qolingani */
export function urlPageSize(value: string | null, list: string, fallback = DEFAULT_PAGE_SIZE): number {
  return validPageSize(value) ?? rememberedPageSize(list, fallback);
}

export function rememberPageSize(list: string, size: number) {
  try {
    localStorage.setItem(storageKey(list), String(size));
  } catch {
    /* ixtiyoriy: xotira yopiq bo'lsa ham tanlov shu sahifada ishlaydi */
  }
}

/** URL'siz ro'yxatlar uchun: [hajm, o'rnatish] -- o'rnatilganda eslab qolinadi */
export function usePageSize(list: string, fallback = DEFAULT_PAGE_SIZE): [number, (size: number) => void] {
  const [size, setSize] = useState(() => rememberedPageSize(list, fallback));
  return [
    size,
    (next: number) => {
      rememberPageSize(list, next);
      setSize(next);
    },
  ];
}
